import { Input } from "@/components/ui/input";
import {
  CellProps,
  Formatted,
  isNumberFormatControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";
import React from "react";

export const NumberFormatCell = (
  props: CellProps & Formatted<number | undefined>,
) => {
  const { id, enabled, uischema, path, handleChange, schema } = props;
  const maxLength = schema.maxLength;
  const formattedNumber: string = props.toFormatted(props.data);

  const onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const validStringNumber = props.fromFormatted(ev.target.value);
    handleChange(path, validStringNumber);
  };

  return (
    <Input
      type="text"
      value={formattedNumber}
      onChange={onChange}
      id={id}
      disabled={!enabled}
      autoFocus={uischema.options?.focus}
      maxLength={uischema.options?.restrict ? maxLength : undefined}
      size={uischema.options?.trim ? maxLength : undefined}
    />
  );
};

export const numberFormatCellTester: RankedTester = rankWith(
  5,
  isNumberFormatControl,
);

// @ts-ignore
export default withJsonFormsCellProps(NumberFormatCell);
